import React from "react"

interface FloatingHelpButtonProps {
    isVisible: boolean
    onClick: () => void
}

const FloatingHelpButton: React.FC<FloatingHelpButtonProps> = ({
    isVisible,
    onClick
}) => {
    if (!isVisible) return null

    return (
        <div className="fixed bottom-6 right-6 z-50 animate-slideIn">
            <button
                onClick={onClick}
                className="w-16 h-16 bg-gradient-to-r from-secondary-1 to-secondary-2 rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-110 transition-all duration-300 animate-bounce-pulse group"
                aria-label="Precisa de ajuda?"
            >
                <div className="flex items-center justify-center w-full h-full">
                    <svg
                        className="w-8 h-8 text-white group-hover:rotate-12 transition-transform duration-300"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>
                </div>
                {/* Indicador de notificação */}
                <div className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full animate-ping"></div>

                {/* Tooltip */}
                <div className="absolute bottom-full left-0 mb-2 px-3 py-1 bg-gray-800 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
                    Precisa de ajuda?
                    <div className="absolute top-full left-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"></div>
                </div>
            </button>
        </div>
    )
}

export default FloatingHelpButton
